export default "__VITE_ASSET__BtsCBsz$__"